<ag-grid-angular
  class="ag-theme-wilson list-height"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
  [components]="components"
  [columnDefs]="columnDefs"
  (selectionChanged)="onSelectionChanged($event)"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>

@let isDrawerVisible = isDrawerVisible$ | async;
@let qualificationDetails = qualificationDetails$ | async;
@let canReadUserQualificationV2Attachments =
  can(RoleAction.Read, RolePermissionSubject.UserQualificationV2);
<wilson-qualification-details-drawer
  [isDrawerVisible]="isDrawerVisible || false"
  [employee]="employee$ | async"
  [qualificationDetails]="qualificationDetails"
  [canReadUserQualificationV2Attachments]="
    canReadUserQualificationV2Attachments
  "
  (closeDrawer)="handleOnCloseDetailsDrawer()"
>
</wilson-qualification-details-drawer>
